
export const OFFER_TEAM_LEADER_GET             = "OFFER_TEAM_LEADER_GET"
export const OFFER_TEAM_LEADER_SET             = "OFFER_TEAM_LEADER_SET"

